import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";

export type SharedoOdsEntityType = "person" | "organisation";

export interface SharedoOdsMatterSummary {
  id: string;
  reference?: string;
  title?: string;
  deepLink: string;
}

export interface SharedoOdsSearchHit {
  odsId: string;
  entityType: string;
  displayName: string;
  firstName?: string;
  surname?: string;
  organisationName?: string;
  reference?: string;
  title?: string;
  email?: string;
  phone?: string;
  hasExistingMatters: boolean;
  matters: SharedoOdsMatterSummary[];
}

export interface SharedoOdsDetail {
  odsId: string;
  entityType: string;
  displayName: string;
  firstName?: string;
  surname?: string;
  organisationName?: string;
  reference?: string;
  title?: string;
  email?: string;
  phone?: string;
}

export interface SharedoOdsSearchResponse {
  results: SharedoOdsSearchHit[];
}

export interface SharedoOdsMattersResponse {
  matters: SharedoOdsMatterSummary[];
}

export interface SharedoOdsSearchRequest {
  query: string;
  entityType: SharedoOdsEntityType;
  environmentId?: string;
  includeMatters?: boolean;
  rowsPerPage?: number;
}

export function createSharedoOdsSearchApi(client: AxiosInstance) {
  return {
    search: async (request: SharedoOdsSearchRequest): Promise<SharedoOdsSearchResponse> => {
      const response = await client.post<SharedoOdsSearchResponse>("/api/sharedo-ods/search", request);
      return response.data;
    },
    getById: async (
      odsId: string,
      entityType: SharedoOdsEntityType,
      environmentId?: string
    ): Promise<SharedoOdsDetail> => {
      const params = new URLSearchParams({ entityType });
      if (environmentId) params.set("environmentId", environmentId);
      const response = await client.get<SharedoOdsDetail>(
        `/api/sharedo-ods/${encodeURIComponent(odsId)}?${params.toString()}`
      );
      return response.data;
    },
    getMatters: async (odsId: string, environmentId?: string): Promise<SharedoOdsMattersResponse> => {
      const params = environmentId ? `?environmentId=${encodeURIComponent(environmentId)}` : "";
      const response = await client.get<SharedoOdsMattersResponse>(
        `/api/sharedo-ods/${encodeURIComponent(odsId)}/matters${params}`
      );
      return response.data;
    },
  };
}

export const sharedoOdsSearchApi = createSharedoOdsSearchApi(apiClient);
